import { createFileRoute } from "@tanstack/react-router";
import EvaluareAuto from "@/pages/EvaluareAuto";
import { routeHead } from "@/lib/seo/route-head";
import { getValuationExample } from "@/lib/valuationExample.functions";
import { valuationFaqSchema } from "@/lib/valuationContent";

export const Route = createFileRoute("/evaluare-auto/")({
  loader: async () => ({ example: await getValuationExample() }),
  staleTime: 0,
  head: () => ({
    ...routeHead("/evaluare-auto/"),
    scripts: [{ type: "application/ld+json", children: JSON.stringify(valuationFaqSchema()) }],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { example } = Route.useLoaderData();
  return <EvaluareAuto example={example} />;
}
